import { BaseDAO } from './baseDAO';
import { Injectable } from '@angular/core';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { Booking } from 'anchor-shared/lib/model/entity/booking';
import { PaymentIntent } from '@stripe/stripe-js/types/api/payment-intents';

@Injectable()
export class BookingDAO extends BaseDAO<Booking> {
  static PATHS = {
    ADD_PASSENGER_BOOKING: '/createBooking',
    MAKE_PAYMENT: '/makeBookingPayment/',
  };

  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.BOOKING);
  }

  public addNewBooking(bookingData: any): Observable<Booking> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      BookingDAO.PATHS.ADD_PASSENGER_BOOKING;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    const httpRequest: Observable<Booking> = this.apiHelper.apiCall<Booking>(
      url,
      method,
      null,
      bookingData,
      headers,
    );

    return Observable.create((observer) => {
      httpRequest.subscribe(
        (booking: Booking) => {
          observer.next(booking);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  // Returns stripe payment intent
  public createPaymentIntent(bookingId: number): Observable<PaymentIntent> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/create-payment-intent';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      bookingId: bookingId,
    };
    return this.apiHelper.apiCall<PaymentIntent>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  public makeBookingPayment(
    bookingId: number,
    paymentData: any,
  ): Observable<any> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      BookingDAO.PATHS.MAKE_PAYMENT +
      bookingId;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    const httpRequest: Observable<Booking> = this.apiHelper.apiCall<Booking>(
      url,
      method,
      null,
      paymentData,
      headers,
    );

    return Observable.create((observer) => {
      httpRequest.subscribe(
        (booking: Booking) => {
          observer.next(booking);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }
}
